import { useAuiState } from '@assistant-ui/react';
import type { ReactNode } from 'react';

import type { DataModelView } from '#core/lib/cognite/view.ts';
import { SessionContext } from '#core/lib/expr/session/SessionContext.ts';

import { useChatSession } from './useChatSession.ts';
import { EvalDepsProvider } from '#plugin-chat/contexts/EvalDepsProvider.tsx';

export function ChatSessionProvider({
  children,
  views,
}: {
  readonly children: ReactNode;
  readonly views: readonly DataModelView[];
}) {
  const threadId = useAuiState(({ threadListItem }) => threadListItem.id);
  const session = useChatSession(threadId);

  return (
    <SessionContext value={session}>
      <EvalDepsProvider views={views}>{children}</EvalDepsProvider>
    </SessionContext>
  );
}
